import { Injectable } from '@angular/core';
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Router } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
       // 
        const token = localStorage.getItem('token');
        if (token) {
            return true;
        }
        this.redirectTo('/auth/sign-in');
        return false;
    }
    private redirectTo(route: string): void {
        this.router.navigate([route]);
    }
}

